import axios from '@axios';

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(typeAlarm => ({
        value: typeAlarm.id,
        label: typeAlarm.name
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/services/pacom/alarm-types', { params })

      if (!data) {
        return []
      }
      commit('setData', data.data)
      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/services/pacom/alarm-types/${id}`, params)

      return data
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
